import React from 'react';
import { motion } from 'framer-motion';
import { testimonialsData } from '../data/testimonials';
import FloatingIcons from './FloatingIcons';

function Testimonials() {
  return (
    <section className="testimonials-section white-wave" id="testimonials">
      <FloatingIcons />
      <div className="container">
        <h3 className="section-title">What People Say</h3>
        <div className="testimonials-wrapper">
          {testimonialsData.map((column, columnIndex) => (
            <div key={columnIndex} className="testimonials-column">
              {column.map((testimonial, index) => (
                <motion.div 
                  key={index} 
                  className="testimonial-card"
                  initial={{ opacity: 0, x: columnIndex === 0 ? -50 : 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-50px" }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  whileHover={{ scale: 1.02, y: -5 }}
                >
                  <div className="testimonial-header">
                    <div className="testimonial-avatar">
                      <img src={testimonial.image} alt={testimonial.name} />
                    </div>
                    <div className="testimonial-info">
                      <div className="testimonial-name">{testimonial.name}</div>
                      <div className="testimonial-title">{testimonial.title}</div>
                    </div>
                  </div>
                  <blockquote className="testimonial-content">
                    {testimonial.message}
                  </blockquote>
                </motion.div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;

